import { useFormik } from 'formik'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
  CRow,
  CTooltip,
} from '@coreui/react-pro'

import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'
import CompleteMarkModal from './CompleteMarkModal'
import ClubService from 'src/service/ClubService'
import moment from 'moment'
import Loader from 'src/components/Loader'
import CIcon from '@coreui/icons-react'
import { cilArrowLeft, cilInfo } from '@coreui/icons'
import MarkAsCompleteModal from './MarkAsCompleteModal'
import ScorecardGrid from './ScorecardGrid'
import { INDOOR_COLUMNS, hasScores } from './scorecardConfig'
import './ScoreCard.css'

const IndoorFullScoreCard = () => {
  const navigate = useNavigate()
  const [visible, setVisible] = useState(false)
  const [completMarkModalVisible, setCompletMarkModalVisible] = useState(false)
  const [finalScorecardModalVisible, setFinalScorecardModalVisible] = useState(false)
  const [defaultInning, setDefaultInning] = useState(1)
  const [scorecardDetails, setScorecardDetails] = useState([])
  const [playerList, setPlayerList] = useState([])
  const [fixtureDetails, setFixtureDetails] = useState({})
  const [loader, setLoader] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [statusValue, setStatusValue] = useState()
  const param = useParams()
  const [gameDetails, setGameDetails] = useState({})

  const fetchData = async (defaultInning = 1) => {
    setScorecardDetails([])
    try {
      const scorecardResponse = await ScorecardService.fullScorecardDetail(
        param.fixtureId,
        defaultInning,
      )
      if (scorecardResponse.status === 200) {
        setScorecardDetails(scorecardResponse.data)

        if (scorecardResponse.player_list.length < 5) {
          ToastComponent(
            'Please add a minimum of 5 players to the squad list of this fixture!',
            'error',
          )
          navigate(`/manage-scores/team-players/${param.fixtureId}`)
          return // Exit early if player list is insufficient
        }
        setPlayerList(scorecardResponse.player_list)
        setFixtureDetails(scorecardResponse.fixtureDetails)
        setStatusValue(scorecardResponse.fixtureDetails.status)
      }

      const clubResponse = await ClubService.getClubDetails()
      if (clubResponse.status === 200) {
        setLoader(false)
        setIsLoading(false)
        setGameDetails(clubResponse.game_details)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      // Handle error here, e.g., show an error toast
    }
  }

  useEffect(() => {
    fetchData()
    // Cleanup (if necessary)
    return () => {
      // Cleanup code here (if any)
    }
  }, [])
  const formik = useFormik({
    initialValues: {
      data: scorecardDetails,
      scorcard_link_name: fixtureDetails?.scorcard_link_name,
      scorcard_link_url: fixtureDetails?.scorcard_link_url,
      fall_of_wickets: fixtureDetails?.fall_of_wickets,
      match_report: fixtureDetails?.match_report,
      potm_match_status: fixtureDetails?.potm_match_status,
      match_status: '',
    },
    enableReinitialize: true,
    onSubmit: (data, actions) => {
      data.fixtureId = param.fixtureId
      data.potm = selectedValue
      data.status = statusValue
      data.inning = defaultInning
      setLoader(true)
      ScorecardService.saveIndoorScorecard(data).then((res) => {
        if (res.status === 200) {
          fetchData()
          setLoader(false)
          ToastComponent(res.message, 'success')
        }
      })
    },
  })
  const [selectedValue, setSelectedValue] = useState([])
  const handleChange = (e) => {
    setSelectedValue(Array.isArray(e) ? e.map((x) => x.value) : [])
  }
  const [completeMarkModalData, setCompleteMarkModalData] = useState([])
  const handleMatchStatus = (e) => {
    setStatusValue(e.target.value)
    const data = {}
    data.fixtureId = param.fixtureId
    data.status = e.target.value
    if (e.target.value === '2') {
      ScorecardService.getSavedScorecardData(data).then((res) => {
        if (res.status === 200) {
          setCompleteMarkModalData(res.data)
          setCompletMarkModalVisible(true)
        }
      })
    } else {
      formikRef.current.handleSubmit()
      ScorecardService.changFixtureStatus(param.fixtureId, e.target.value)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            navigate(`/full-scorecard/${param.fixtureId}`)
          } else {
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          console.log('e', e)
          ToastComponent('Something went wrong.', 'error')
        })
    }
  }

  const formikRef = React.useRef()
  useEffect(() => {
    formikRef.current = formik
  }, [formik])

  const changeInning = (e) => {
    setDefaultInning(e.target.value)
    fetchData(e.target.value)
  }

  const [isMobile, setIsMobile] = useState(false)
  // Function to update the isMobile state based on the screen width
  const updateScreenSize = () => {
    setIsMobile(window.innerWidth <= 768) // Adjust the breakpoint as needed
  }
  // Use useEffect to update the screen size state on component mount and window resize
  useEffect(() => {
    updateScreenSize() // Initial check
    window.addEventListener('resize', updateScreenSize)

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateScreenSize)
    }
  }, [])
  function formatFantasyPoints(fantasyPoints) {
    // Check if there are decimal digits
    if (fantasyPoints % 1 !== 0) {
      return fantasyPoints.toFixed(2).replace(/0+$/, '') // Remove trailing zeros
    } else {
      return fantasyPoints.toString() // Convert to a string without decimal places
    }
  }
  const [infoPageModal, setInfoPageModal] = useState(false)
  const handleInfoClick = () => {
    setInfoPageModal(true)
  }

  const handleInputChange = (event, type) => {
    formik.handleChange(event) // Update formik state
    const data = {}
    data.fixtureId = param.fixtureId
    data.type = type
    data.value = event.target.value
    ScorecardService.updateCustomScorecardField(data).then((res) => {
      if (res.status === 200) {
        setLoader(false)
        ToastComponent(res.message, 'success')
      }
    })
  }
  // ---- presentation helpers ------------------------------------------------

  // This screen has always hardcoded the indoor column set rather than reading
  // one from the API, so it keeps using the shared list.
  const columns = INDOOR_COLUMNS

  const enteredCount = (scorecardDetails || []).filter((item) => hasScores(item, columns)).length
  const playerCount = (scorecardDetails || []).length
  const enteredPercent = playerCount ? Math.round((enteredCount / playerCount) * 100) : 0

  const scorecardTitle = fixtureDetails.scorcard_link_url ? (
    <Link to={fixtureDetails.scorcard_link_url} target="_blank">
      Player stats
    </Link>
  ) : (
    'Player stats'
  )

  return (
    <>
      <CForm onSubmit={formik.handleSubmit}>
        <div className="ge-page-header">
          <button type="button" className="ge-back-link" onClick={() => navigate(-1)}>
            <CIcon icon={cilArrowLeft} />
            Back
          </button>
          <h1 className="ge-page-title">Full scorecard &mdash; {fixtureDetails.team_name}</h1>
          <p className="ge-page-subtitle">
            The saved scorecard for this innings, read only. Edit scores from Manage Scores.
          </p>
        </div>

        <div className="ge-meta-strip">
          <div className="ge-meta-item">
            <span className="ge-meta-label">Round</span>
            <span className="ge-meta-value">{fixtureDetails.round}</span>
          </div>
          <div className="ge-meta-item">
            <span className="ge-meta-label">Team</span>
            <span className="ge-meta-value">{fixtureDetails.team_name}</span>
          </div>
          <div className="ge-meta-item">
            <span className="ge-meta-label">Starts</span>
            <span className="ge-meta-value">
              {moment(fixtureDetails.start_date).format('D MMM YYYY')}
              {', '}
              {moment(fixtureDetails.start_time, ['HH:mm']).format('h:mma')}
            </span>
          </div>
          <div className="ge-meta-item">
            <span className="ge-meta-label">Ends</span>
            <span className="ge-meta-value">
              {moment(fixtureDetails.end_date).format('D MMM YYYY')}
              {', '}
              {moment(fixtureDetails.end_time, ['HH:mm']).format('h:mma')}
            </span>
          </div>
        </div>

        <div className="sc-toolbar">
          <div className="d-flex flex-wrap align-items-center gap-3">
            {fixtureDetails?.match_type === 28 && (
              <div className="d-flex align-items-center gap-2">
                <CFormLabel
                  htmlFor="inning"
                  className="mb-0 small fw-semibold text-medium-emphasis"
                >
                  Innings
                </CFormLabel>
                <CFormSelect
                  aria-label="select inning"
                  name="inning"
                  onChange={changeInning}
                  value={defaultInning}
                  id="inning"
                  style={{ width: 150 }}
                >
                  <option value={1}>1st Innings</option>
                  <option value={2}>2nd Innings</option>
                </CFormSelect>
              </div>
            )}
          </div>
          <div className="d-flex align-items-center gap-2">
            <span className="small fw-medium text-medium-emphasis">
              {enteredCount} of {playerCount} players have scores
            </span>
            <div className="sc-progress-track">
              <div className="sc-progress-fill" style={{ width: `${enteredPercent}%` }} />
            </div>
          </div>
        </div>

        <CCard className="mb-4">
          <CCardHeader>
            <strong>{scorecardTitle}</strong>
          </CCardHeader>
          <CCardBody>
            {loader || isLoading ? (
              <Loader />
            ) : (
              <ScorecardGrid
                columns={columns}
                rows={scorecardDetails}
                isMobile={isMobile}
                readOnly
                formatFantasyPoints={formatFantasyPoints}
              />
            )}
          </CCardBody>
        </CCard>

        <CCard className="mb-4">
          <CCardHeader>
            <strong>Scorecard Details</strong>
          </CCardHeader>
          <CCardBody>
            <CRow className="g-3">
              <CCol md={6}>
                <CFormLabel htmlFor="scorcard_link_name">Scorecard Source</CFormLabel>
                <input
                  type="text"
                  name="scorcard_link_name"
                  className={'form-control'}
                  id="scorcard_link_name"
                  placeholder="Scorecard Source"
                  defaultValue={formik.values.scorcard_link_name}
                  onChange={(e) => handleInputChange(e, 'scorcard_link_name')}
                />
              </CCol>
              <CCol md={6}>
                <CFormLabel htmlFor="scorcard_link_url">Scorecard Link</CFormLabel>
                <input
                  type="text"
                  name="scorcard_link_url"
                  className={'form-control'}
                  id="scorcard_link_url"
                  placeholder="Scorecard Link"
                  defaultValue={formik.values.scorcard_link_url}
                  onChange={(e) => handleInputChange(e, 'scorcard_link_url')}
                />
              </CCol>
              {/* <CCol md={6}>
                <CFormLabel htmlFor="fall_of_wickets">Fall of Wickets</CFormLabel>
                <CFormTextarea
                  id="fall_of_wickets"
                  aria-label="Fall of wickets"
                  defaultValue={formik.values.fall_of_wickets}
                  name={'fall_of_wickets'}
                  onChange={(e) => handleInputChange(e, 'fall_of_wickets')}
                ></CFormTextarea>
              </CCol> */}
            </CRow>
          </CCardBody>
        </CCard>

        <CCard className="mt-3">
          <CCardHeader>
            <strong>Match status</strong>
            <div className="text-medium-emphasis small">
              The last step - choosing Completed opens a final review of the saved scorecard.
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={6}>
                <div className="d-flex align-items-center gap-2">
                  <CFormSelect
                    aria-label="Select Structure"
                    name="match_status"
                    value={statusValue}
                    id="match_status"
                    onChange={handleMatchStatus}
                  >
                    <option value={0}>Select Match Status </option>
                    <option value={1}>In-Progress</option>
                    <option value={2}>Completed</option>
                  </CFormSelect>
                  <CTooltip content="What the match statuses mean">
                    <CButton
                      color="secondary"
                      variant="ghost"
                      onClick={() => setVisible(!visible)}
                      aria-label="Match status help"
                    >
                      <CIcon icon={cilInfo} />
                    </CButton>
                  </CTooltip>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CForm>

      <CompleteMarkModal visible={visible} setVisible={setVisible} />
      <MarkAsCompleteModal
        completMarkModalVisible={completMarkModalVisible}
        setCompletMarkModalVisible={setCompletMarkModalVisible}
        data={completeMarkModalData}
        fixtureId={param.fixtureId}
        finalScorecardModalVisible={finalScorecardModalVisible}
        setFinalScorecardModalVisible={setFinalScorecardModalVisible}
      />
    </>
  )
}

export default IndoorFullScoreCard
